import Icon from 'gcs-common/components/Icon/Icon';
import InfoTooltip from 'gcs-common/components/InfoTooltip/InfoTooltip';
import RowMemberList from 'gcs-common/components/RowMemberList/RowMemberList';
import { ICON, ICON_COLOR, ICON_SIZE } from 'gcs-common/constants/IconConstants';
import {
  getAssignmentMembers,
  getCommunicationAssignment,
  getCommunicationAssignmentMainAgent,
} from 'gcs-common/slices/administration/erpCustomerAssignments/erpCustomerAssignmentsSelectors';
import {
  CommunicationAssignmentDirection,
  CommunicationAssignmentType,
} from 'gcs-common/slices/administration/houseCommunicationStructures/houseCommunicationStructuresConstants';
import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import CommunicationAssignmentSettings from '../CommunicationAssignmentSettings/CommunicationAssignmentSettings';
import styles from './styles.module.scss';

const ErpCustomerAssignmentRowCollapsed = ({ communicationAssignmentId, setOpenRowId }) => {
  const assignment = useSelector(getCommunicationAssignment(communicationAssignmentId));
  const isTeamRow = assignment.type === CommunicationAssignmentType.SALES_SPACE;
  const assignmentMainAgent = useSelector(getCommunicationAssignmentMainAgent(communicationAssignmentId));
  const assignmentMembers = useSelector(getAssignmentMembers(communicationAssignmentId));

  const directionIcon = () => {
    if (assignment.direction === CommunicationAssignmentDirection.BIDIRECTIONAL) {
      return <Icon Icon={ICON.CYCLE_ARROWS} color={ICON_COLOR.BLACK} size={ICON_SIZE.X_SMALL} />;
    }
    return <Icon Icon={ICON.ARROW_LONG} color={ICON_COLOR.BLACK} size={ICON_SIZE.X_SMALL} />;
  };

  const onExpandButtonClick = useCallback(() => {
    setOpenRowId(communicationAssignmentId);
  }, [setOpenRowId, communicationAssignmentId]);

  const isDefaultAssignment = assignment.isGeneratedFromStructure;
  let leftBorderClassName = isDefaultAssignment ? styles.defaultAssignment : styles.customAssignment;
  let tooltipText = isDefaultAssignment ? 'Generierte Kommunikationszuweisung' : 'Kommunikationszuweisung';

  if (assignment.isEdited && isDefaultAssignment) {
    leftBorderClassName = styles.defaultAssignmentEdited;
    tooltipText = `${tooltipText} (Bearbeitet)`;
  }

  return (
    <div className={styles.rowContainer} onClick={onExpandButtonClick} role="button" tabIndex={0}>
      <div className={leftBorderClassName}>
        <InfoTooltip text={tooltipText} showIcon={false} />
      </div>
      <div className={styles.dataRow}>
        <div className={styles.direction}>{directionIcon()}</div>
        {isTeamRow && (
          <div className={styles.nameContainer}>
            <div className={styles.name}>{assignment.channelName}</div>
          </div>
        )}

        <RowMemberList
          isTeamRow={isTeamRow}
          assignmentMainAgent={assignmentMainAgent}
          assignmentMembers={assignmentMembers}
        />
      </div>
      <CommunicationAssignmentSettings
        communicationAssigmentId={assignment.id}
        onExpandButtonClick={onExpandButtonClick}
        rowType="collapsed"
      />
    </div>
  );
};

ErpCustomerAssignmentRowCollapsed.propTypes = {
  communicationAssignmentId: PropTypes.string.isRequired,
  setOpenRowId: PropTypes.func.isRequired,
};

export default ErpCustomerAssignmentRowCollapsed;
